import useHasPermission from 'hooks/useHasPermission';
import notistack from 'pages/Core/Notistack';
import React, { useState, useEffect, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import { useForm, Controller, useWatch } from 'react-hook-form';
import Select from 'react-select';
import { GetStoresSelectListBySateIdAndCityId } from "pages/Componets/API_Modal/StoreMasterAPIModal";
import { getMaterialTypeSelectList, getOptionsSelectList } from "pages/Componets/API_Modal/MaterialTypeMasterAPIModal";
import { getMRPTypeSelectList, getDiscountTypeSelectList, getDiscountOnMRPSelectList, getDiscountOnSRPSelectList } from "pages/Componets/API_Modal/DiscountAPI/DiscountAPIModal";
import { getAllInvoiceAmtSlabForSelect, getAllstyleNumber } from "pages/Componets/API_Modal/RewardMasterAPIModal";
import { createDiscount } from "pages/Componets/API_Modal/DiscountAPI/DiscountAPIModal";
import { DiscountDataModel } from '../model/discount.model';
import { getAllCityData, getAllCountryForSelect, getAllStateData, getStateByCountryId } from 'pages/Componets/API_Modal';
import { toast } from 'react-toastify';
import { SelectListItem } from 'pages/Core';
import { apiClient } from 'helpers/api_helper';
import { borderRadius, margin, padding, width } from '@mui/system';
import { handleKeyDown } from 'Common/Modal/ModalTriggerButton';
import MultiSelectWithSelectAll from './MultiSelectWithSelectAll';
import DuplicateOffersModal from './DuplicateOffersModal';

interface AddDiscountProp {
    reloadDataSource(): void;
}

interface SelectOption {
    value: string | number;
    label: string;
    text: string;
}

const AddDiscount: React.FC<AddDiscountProp> = ({ reloadDataSource }) => {
    const skipFetchRef = useRef(false);
    const isSubmittingRef = useRef(false);

    const [selectedStates, setSelectedStates] = useState<SelectOption[]>([]);
    const [selectedCities, setSelectedCities] = useState<SelectOption[]>([]);


    const HasPermission = useHasPermission();
    const [showModal, setShowModal] = useState(false);
    const [storeAllData, setStoreAllData] = useState<{ label: string; value: string | number }[]>([]);
    const [stateAllData, setStateAllData] = useState<{ label: string; value: number, text: string }[]>([]);
    const [cityAllData, setCityAllData] = useState<{ label: string; value: number, text: string }[]>([]);
    const [materialTypeData, setMaterialTypeData] = useState<{ label: string; value: number }[]>([]);
    const [styleNumber, setStyleNumber] = useState<{ label: string; value: string }[]>([]);
    const [allMRPTypeData, setAllMRPTypeData] = useState<{ label: string; value: number }[]>([]);
    const [allDiscountTypeData, setAllDiscountTypeData] = useState<{ label: string; value: number }[]>([]);
    const [allDiscountOnMRP, setAllDiscountOnMRP] = useState<{ label: string; value: number }[]>([]);
    const [allDiscountOnSRP, setAllDiscountOnSRP] = useState<{ label: string; value: number }[]>([]);
    const [invoiceSlabData, setInvoiceSlabData] = useState<{ label: string; value: number }[]>([]);
    const [countryId, setCountryId] = useState('');
    const [isAllStore, setIsAllStore] = useState(false);
    const [isClub, setIsClub] = useState(false);
    const inputRef = useRef<HTMLInputElement>(null);
    const [collection, setCollection] = useState<{ label: string; value: string }[]>([]);
    const [category, setCategory] = useState<{ label: string; value: string }[]>([]);
    const [ktType, setKtType] = useState<{ label: string; value: string }[]>([]);

    const [selectedStores, setSelectedStores] = useState<any[]>([]);

    const getCityListByStateId = async (ids: number[]) => {
        try {
            const params = new URLSearchParams();
            ids.forEach((id: any) => params.append('stateId', id.value.toString()));
            const url = `/api/v1/City/GetCitySelectListByStateIdList?${params.toString()}`;
            const response = await apiClient.get(url);
            return response;
        } catch (error: any) {
            throw new Error(error?.message || "Error fetching city list");
        }
    };


    const getTodayDate = () => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    };
    const {
        register,
        control,
        handleSubmit,
        formState: { errors, isSubmitting },
        reset,
        setValue,
        watch,
        trigger,
    } = useForm<DiscountDataModel>({
        defaultValues: {
            promotionName: '',
            storeIdList: null,
            stateIdList: null,
            cityIdList: null,
            mrpTypeId: null,
            invoiceSlabId: null,
            discountOnSRPOptionId: null,
            discountOnMRPOptionId: null,
            discountTypeId: null,
            discountValue: '',
            materialTypeId: null,
            fromDate: '',
            toDate: '',
            styleNumber: null,
            isPercentage: false,
            isDefault: false,
            isAllStore: false,
            isClub: false,
        },
        mode: "onBlur"
    });

    const isPercentage = watch("isPercentage");
    const watchMrpTypeId = watch("mrpTypeId");
    const watchDiscountTypeId = watch("discountTypeId");
    const watchIsStyleNo = watch("isStyleNo");
    const watchFromDate = watch("fromDate");
    const watchStateIds = useWatch({ control, name: 'stateIdList' });
    const watchCityIds = useWatch({ control, name: 'cityIdList' });
    const selectAllOption = { label: "Select All", value: "*", text: "Select All" };
    const modifiedStoreOptions = [selectAllOption, ...storeAllData];
    const modifiedStateOptions = [selectAllOption, ...stateAllData];
    const modifiedCityOptions = [selectAllOption, ...cityAllData];


    useEffect(() => {

        const fetchCountries = async () => {
            try {
                const res = await getAllCountryForSelect();
                const india = res.data.find((item: any) => item.text === "India");
                if (india) {
                    setCountryId(india.value);
                }
            } catch (err) {
                toast.error("Failed to load countries");
            }
        };
        fetchCountries();
    }, []);

    useEffect(() => {
        if (!countryId) return;

        const fetchStates = async () => {
            try {
                const res = await getStateByCountryId(countryId);
                setStateAllData(res?.data?.map((item: any) => ({
                    label: item.text,
                    value: Number(item.value)
                })) || []);
            } catch (err) {
                toast.error("Failed to load states");
            }
        };
        fetchStates();
    }, [countryId]);

    useEffect(() => {
        const fetchCities = async () => {
            if (!watchStateIds || watchStateIds.length === 0) {
                setCityAllData([]);
                setValue("cityIdList", []);
                return;
            }

            try {
                const response = await getCityListByStateId(watchStateIds);

                const mergedCities = response?.data?.map((item: any) => ({
                    label: item.text,
                    value: Number(item.value),
                })) || [];

                const uniqueCities: any = Array.from(
                    new Map(mergedCities.map((city: any) => [city.value, city])).values()
                );

                setCityAllData(uniqueCities);
            } catch (err) {
                toast.error("Failed to load cities");
            }
        };

        fetchCities();
    }, [watchStateIds]);


    const fetchStores = async () => {
        if (!showModal) return;

        try {
            let stateId: number[] | undefined = undefined;
            let cityId: number[] | undefined = undefined;

            if (watchStateIds && watchStateIds.length > 0) {
                stateId = watchStateIds.map((item: any) => item.value);
            }

            if (watchCityIds && watchCityIds.length > 0) {
                cityId = watchCityIds.map((item: any) => item.value);
            }

            const response = await GetStoresSelectListBySateIdAndCityId({ stateId, cityId });

            const stores =
                response?.data?.map((item: any) => ({
                    label: item.text,
                    value: Number(item.value),
                })) || [];

            if (selectedStates.length > 0 || selectedCities.length > 0) {
                setStoreAllData(stores);
                setSelectedStores((prevSelected) => {
                    if (prevSelected && prevSelected.length > 0) {
                        const validSelections = prevSelected.filter((sel) =>
                            stores.some((store: any) => store.value === sel.value)
                        );

                        setValue("storeIdList", validSelections);
                        setTimeout(() => {
                            trigger("storeIdList");
                        }, 0);

                        return validSelections;
                    } else {
                        setValue("storeIdList", stores);
                        setTimeout(() => {
                            trigger("storeIdList");
                        }, 0);

                        return stores;
                    }
                });
            } else {
                setValue("storeIdList", []);
            }

        } catch (err) {
            console.error("Error fetching stores:", err);
        }
    };


    const getAllStoreData = async () => {
        try {
            const response = await GetStoresSelectListBySateIdAndCityId();

            const stores = response?.data?.map((item: any) => ({
                label: item.text,
                value: Number(item.value)
            })) || [];
            setStoreAllData(stores);
            // setValue('storeIdList', stores);
            if ((!watchStateIds || watchStateIds.length === 0)) {
                setValue('storeIdList', stores);
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleAllowOfferCombinationChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const checked = e.target.checked;
        setIsClub(checked);
        setValue("isClub", checked);
    };

    useEffect(() => {
        if (skipFetchRef.current || isSubmittingRef.current) return;
        if (!showModal) return
        getAllStoreData()
    }, [showModal])

    useEffect(() => {
        if (skipFetchRef.current || isSubmittingRef.current) return;
        if (!isAllStore) {
            fetchStores();
        }

    }, [watchStateIds, watchCityIds]);


    useEffect(() => {
        if (showModal) {
            const fetchData = async () => {
                try {
                    const [
                        data
                    ] = await Promise.all([
                        getOptionsSelectList(),
                    ]);

                    setMaterialTypeData(data.data?.materialTypeSelectList?.map((item: any) => ({
                        label: item.text,
                        value: Number(item.value)
                    })) || []);

                    setAllMRPTypeData(data.data?.productPriceTypeSelectList?.map((item: any) => ({
                        label: item.text,
                        value: Number(item.value)
                    })) || []);

                    setAllDiscountTypeData(data.data?.discountTypeSelectList?.map((item: any) => ({
                        label: item.text,
                        value: Number(item.value)
                    })) || []);


                    setAllDiscountOnMRP(data.data?.discountOnMrpTypeSelectList?.map((item: any) => ({
                        label: item.text,
                        value: Number(item.value)
                    })) || []);

                    setAllDiscountOnSRP(data.data?.discountOnSrpTypeSelectList?.map((item: any) => ({
                        label: item.text,
                        value: Number(item.value)
                    })) || []);

                    setInvoiceSlabData(data.data?.invoiceSlabSelectList?.map((item: any) => ({
                        label: item.text,
                        value: Number(item.value)
                    })) || []);

                    setStyleNumber(data.data?.styleNoSelectList?.map((item: any) => ({
                        label: item.text,
                        value: Number(item.value)
                    })) || []);

                    setCollection(data.data?.collectionSelectList?.map((item: any) => ({
                        label: item.text,
                        value: Number(item.value)
                    })) || []);

                    setCategory(data.data?.categorySelectList?.map((item: any) => ({
                        label: item.text,
                        value: Number(item.value)
                    })) || []);

                    setKtType(data.data?.karatSelectList?.map((item: any) => ({
                        label: item.text,
                        value: Number(item.value)
                    })) || []);
                } catch (error) {
                    console.error("Error fetching dropdown data:", error);
                }
            };
            fetchData();
        }
    }, [showModal]);


    useEffect(() => {
        if (watchMrpTypeId === 1) {
            setValue("discountOnSRPOptionId", null);
        } else if (watchMrpTypeId === 2) {
            setValue("discountOnMRPOptionId", null);
        }
    }, [watchMrpTypeId, setValue]);

    useEffect(() => {
        if (watchDiscountTypeId !== 2) {
            setValue("invoiceSlabId", null);
        }
    }, [watchDiscountTypeId, setValue]);

    useEffect(() => {
        if (!watchIsStyleNo) {
            setValue("styleNumber", null);
        }
    }, [watchIsStyleNo, setValue]);

    const handleAllStoresChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const checked = e.target.checked;
        setIsAllStore(checked);

        if (checked) {
            setValue("stateIdList", []);
            setValue("cityIdList", []);
            setSelectedStates([])
            setSelectedCities([])
            try {
                const response = await GetStoresSelectListBySateIdAndCityId();
                const stores: SelectOption[] =
                    response?.data?.map((item: any) => ({
                        label: item.text,
                        value: Number(item.value),
                    })) || [];

                setStoreAllData(stores);

                setValue("storeIdList", stores);
            } catch (error) {
                console.error("Error fetching all stores:", error);
                setValue("storeIdList", []);
            }
        } else {
            setValue("stateIdList", []);
            setValue("cityIdList", []);
            setValue("storeIdList", []);
            setSelectedStates([])
            setSelectedCities([])
            setStoreAllData([]);
        }
    };

    const handleOpen = () => {
        reset();
        setIsAllStore(true);
        setIsClub(false);
        setShowModal(true);
    };

    const closeModal = () => {
        reset();
        setIsAllStore(false);
        setIsClub(false);
        setShowModal(false);
        setSelectedStores([])
        isSubmittingRef.current = false;
        skipFetchRef.current = false;
    };

    const [confirmMsg, setConfirmMsg] = useState('');
    const [dublicateData, setDublicateData] = useState<any[]>([]);
    const [payload, setPayload] = useState<any>(null);
    const [showDublicateDataModal, setShowDublicateDataModal] = useState(false);
    const onSubmit = async (data: DiscountDataModel) => {
        isSubmittingRef.current = true; // Prevent API calls during submission
        skipFetchRef.current = true;

        try {
            let storeIds;

            if (isAllStore) {
                storeIds = storeAllData.map(store => store.value);
            } else {
                storeIds = Array.isArray(data.storeIdList)
                    ? data.storeIdList.map((store: any) => typeof store === 'object' ? store.value : store)
                    : null;
            }
            const newPayloadRaw = {
                promotionName: data.promotionName,
                stateId: null,
                cityId: null,
                storeIds: storeIds ?? null,
                mrpTypeId: data.mrpTypeId,
                invoiceSlabId: data.invoiceSlabId || 0,
                discountOnSRPOptionId: data.discountOnSRPOptionId,
                discountOnMRPOptionId: data.discountOnMRPOptionId,
                discountTypeId: data.discountTypeId,
                discountValue: data.discountValue,
                materialTypeId: data.materialTypeId,
                fromDate: data.fromDate ? new Date(data.fromDate).toISOString() : null,
                toDate: data.toDate ? new Date(data.toDate).toISOString() : null,
                isPercentage: Boolean(data.isPercentage),
                isDefault: Boolean(data.isDefault),
                isAllStore: Boolean(data.isAllStore),
                isClub: Boolean(data.isClub),
                stylesId:
                    data?.styleNumber && data.styleNumber.length > 0
                        ? data.styleNumber.map((item: any) => item.value)
                        : null,
                ktId:
                    data?.ktTypeList && data.ktTypeList.length > 0
                        ? data.ktTypeList.map((item: any) => item.value)
                        : null,
                collectionId:
                    data?.collectionList && data.collectionList.length > 0
                        ? data.collectionList.map((item: any) => item.value)
                        : null,
                categoryId:
                    data?.categoryList && data.categoryList.length > 0
                        ? data.categoryList.map((item: any) => item.value)
                        : null,

                mrpType:
                    allMRPTypeData.find((m) => m.value === data.mrpTypeId)?.label || "",
                discountType:
                    allDiscountTypeData.find((d) => d.value === data.discountTypeId)?.label ||
                    "",
                discountOn:
                    allDiscountOnSRP.find((d) => d.value === data.discountOnSRPOptionId)?.label ||
                    allDiscountOnMRP.find((d) => d.value === data.discountOnMRPOptionId)?.label ||
                    "",
                invoiceSlab:
                    invoiceSlabData.find((i) => i.value === data.invoiceSlabId)?.label || "",
                materialType:
                    materialTypeData.find((m) => m.value === data.materialTypeId)?.label || "",

                isConfirm: false,
            }
            const newPayload = Object.fromEntries(
                Object.entries(newPayloadRaw).filter(
                    ([, value]) => value !== null && value !== undefined
                )
            );
            setPayload(newPayload);
            const response: any = await createDiscount(newPayload);
            if (response?.status === 200) {
                notistack.notifyFromApi(response);
                closeModal();
                reloadDataSource();
                setSelectedStores([])
            } else if (response?.status === 400) {
                notistack.warning(response.message);
                setShowDublicateDataModal(true)
                setDublicateData(response.data)
                setConfirmMsg(response.message)
            }
        } catch (error: any) {
            notistack.error(error.message);
        }
    };
    const customStyles = (selectedValues: any[], visibleValue: any) => ({
        control: (provided: any, state: any) => ({
            ...provided,
            width: "15rem",
            height: '30px',
            minHeight: '30px',
            margin: '0px 150px 0px 0px ',
            fontSize: '13px',
            marginRight: "1rem",
            backgroundColor: '#fff',
            alignItems: 'center',
            borderColor: state.isFocused ? '#80bdff' : '#ced4da',
            // boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(0, 123, 255, 0.25)' : 'none',
            '&:hover': { borderColor: '#515151ff' },
        }),
        menu: (base: any) => ({
            ...base,
            zIndex: 9999,
            marginTop: '0.25rem',
            border: '1px solid rgba(0, 0, 0, 0.1)',
        }),
        option: (provided: any, state: any) => ({
            ...provided,
            padding: '8px 12px',
            fontSize: '14px',
            color: state.isSelected
                ? '#fff'
                : "#1a1a1a",
            backgroundColor: state.isSelected
                ? '#298dff'
                : state.isFocused
                    ? '#f8f9fa'
                    : '#fff',
            '&:active': { backgroundColor: '#dadada' },
        }),
        multiValue: (base: any, state: any) =>
            selectedValues.length > 1 && state.data.label !== visibleValue?.label
                ? { ...base, display: 'none' }
                : { ...base, backgroundColor: 'rgba(0, 0, 0, 0.06)', maxHeight: '24px', width: "9rem" },
        multiValueLabel: (base: any, state: any) =>
            selectedValues.length > 1 && state.data.label !== visibleValue?.label
                ? { ...base, display: 'none' }
                : {
                    ...base,
                    color: 'black',
                    fontWeight: '500',
                    padding: '2px 6px',
                    fontSize: '12px',
                },
        multiValueRemove: (base: any, state: any) =>
            selectedValues.length > 1 && state.data.label !== visibleValue?.label
                ? { ...base, display: 'none' }
                : {
                    ...base,
                    color: 'black',
                    ':hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.1)',
                        color: 'black',
                    },
                },
        valueContainer: (base: any) => ({
            ...base,
            padding: '0 8px',
            height: '30px',
            display: 'flex',
            alignItems: 'center',
        }),
        indicatorsContainer: (base: any) => ({
            ...base,
            height: '30px',
            display: 'flex',
            alignItems: 'center',
            paddingRight: '4px',
        }),
        dropdownIndicator: (base: any) => ({
            ...base,
            padding: '4px',
            color: '#6c757d',
            height: '30px',
            display: 'flex',
            alignItems: 'center',
            ':hover': { color: '#495057' },
        }),
        clearIndicator: (base: any) => ({
            ...base,
            padding: '4px',
            color: '#6c757d',
            height: '30px',
            display: 'flex',
            alignItems: 'center',
            ':hover': { color: '#495057' },
        }),
    });

    const customStyle = (selectedValues: any[]) => ({
        control: (provided: any, state: any) => ({
            ...provided,
            width: "15rem",
            minHeight: 30,
            height: 30,
            fontSize: "11px",
            backgroundColor: "#fff",
            alignItems: "center",
            boxShadow: "none",
        }),

        multiValue: (base: any, state: any) => {
            const index = selectedValues.findIndex(
                (v: any) => v.value === state.data.value
            );
            return index >= 2
                ? { ...base, display: "none" } // hide beyond 2
                : { ...base, backgroundColor: "rgba(0, 0, 0, 0.06)" };
        },

        multiValueLabel: (base: any, state: any) => {
            const index = selectedValues.findIndex(
                (v: any) => v.value === state.data.value
            );
            return index >= 2
                ? { ...base, display: "none" }
                : { ...base, fontSize: "12px", fontWeight: 500 };
        },

        multiValueRemove: (base: any, state: any) => {
            const index = selectedValues.findIndex(
                (v: any) => v.value === state.data.value
            );
            return index >= 2
                ? { ...base, display: "none" }
                : {
                    ...base,
                    color: "black",
                    ":hover": {
                        backgroundColor: "rgba(0,0,0,0.1)",
                    },
                };
        },

        valueContainer: (base: any) => ({
            ...base,
            padding: "0 8px",
            height: "30px",
            display: "flex",
            alignItems: "center",
        }),
    });

    return (
        <>
            {HasPermission("ConsumerOffers.Read") && (
                <div className="d-flex gap-2">
                    <button
                        onKeyDown={handleKeyDown}
                        className="btn btn-sm "
                        style={{ border: "1px solid #000" }}
                        onClick={handleOpen}
                        type="button"
                    >
                        <i className="bi bi-plus-lg" /> Add Consumer Offer
                    </button>
                </div>
            )}

            <Modal
                show={showModal}
                onHide={closeModal}
                backdrop="static"
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add Consumer Offer</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit(onSubmit)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                                const form = e.currentTarget.closest("form");
                                if (form) form.requestSubmit();
                            }
                        }}
                    >
                        <div className="d-flex justify-content-end mb-0 p-0">
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="allStores"
                                    {...register("isAllStore")}
                                    checked={isAllStore}
                                    onChange={handleAllStoresChange}
                                />
                                <label className="form-check-label" htmlFor="allStores">
                                    All Stores
                                </label>
                            </div>
                        </div>
                        <button type="submit" style={{ display: "none" }} tabIndex={-1} />
                        {(!isAllStore) ? <>
                            <div className="row">

                                <div className='col-md-4' >
                                    <label className='form-label'>State</label>
                                    <Controller
                                        name='stateIdList'
                                        control={control}
                                        render={({ field }) => {
                                            const selectedValues = field.value || [];
                                            const visibleValue = selectedValues[0];

                                            return (
                                                <div className="position-relative" >
                                                    <Select
                                                        {...field}
                                                        options={modifiedStateOptions}
                                                        isMulti
                                                        closeMenuOnSelect={false}
                                                        hideSelectedOptions={false}
                                                        placeholder="--Select state--"
                                                        className="react-select-container"
                                                        classNamePrefix="react-select"
                                                        value={selectedValues}
                                                        getOptionLabel={(e: SelectOption) => e.label}
                                                        getOptionValue={(e: SelectOption) => e.value}
                                                        styles={customStyle(selectedValues)}
                                                        onChange={(selected: SelectOption[] | null) => {
                                                            const values = selected || [];
                                                            if (!selected) {
                                                                field.onChange([]);
                                                                setValue("cityIdList", []);
                                                                setSelectedStates([]);
                                                                return;
                                                            }

                                                            const isSelectAllSelected = selected.some(
                                                                (option) => option.value === "*"
                                                            );

                                                            if (isSelectAllSelected) {
                                                                field.onChange(modifiedStateOptions.slice(1));
                                                                setValue("cityIdList", []);
                                                                document.activeElement instanceof HTMLElement &&
                                                                    document.activeElement.blur();
                                                                const allStates = modifiedStateOptions.slice(1);
                                                                setSelectedStates(allStates);
                                                            } else if (
                                                                selected.length === stateAllData.length &&
                                                                field.value?.length !== stateAllData.length
                                                            ) {
                                                                field.onChange(modifiedStateOptions.slice(1));
                                                                const allStates = modifiedStateOptions.slice(1);
                                                                setSelectedStates(allStates);
                                                                setValue("cityIdList", []);
                                                            } else {
                                                                field.onChange(selected);
                                                                setSelectedStates(selected);
                                                                setValue("cityIdList", []);
                                                            }
                                                            setValue("cityIdList", []);
                                                        }}

                                                        isDisabled={isAllStore}
                                                    />
                                                    {selectedValues.length > 2 && (
                                                        <span className="translate-middle-y end-0 me-3 badge rounded-pill bg-light text-primary border border-primary">
                                                            +{selectedValues.length - 2} more
                                                        </span>
                                                    )}
                                                </div>
                                            );
                                        }}
                                    />
                                </div>

                                <div className='col-md-4'>
                                    <label className='form-label'>City</label>
                                    <Controller
                                        name='cityIdList'
                                        control={control}
                                        render={({ field }) => {
                                            const selectedValues = field.value || [];
                                            const visibleValue = selectedValues[0];

                                            return (
                                                <div className="position-relative">
                                                    <Select
                                                        {...field}
                                                        options={modifiedCityOptions}
                                                        isMulti
                                                        closeMenuOnSelect={false}
                                                        hideSelectedOptions={false}
                                                        placeholder="--Select city--"
                                                        className="react-select-container"
                                                        classNamePrefix="react-select"
                                                        isDisabled={!watchStateIds || watchStateIds.length === 0 || isAllStore}
                                                        value={selectedValues}
                                                        getOptionLabel={(e: SelectOption) => e.label}
                                                        getOptionValue={(e: SelectOption) => e.value}
                                                        styles={customStyle(selectedValues)}
                                                        onChange={(selected: SelectOption[] | null) => {
                                                            // field.onChange(selected || []);
                                                            if (!selected) {
                                                                field.onChange([]);
                                                                return;
                                                            }
                                                            if (!selected) {
                                                                field.onChange([]);
                                                                setSelectedCities([]);
                                                                return;
                                                            }

                                                            const isSelectAllSelected = selected.some(
                                                                (option) => option.value === "*"
                                                            );

                                                            if (isSelectAllSelected) {
                                                                field.onChange(modifiedCityOptions.slice(1));
                                                                document.activeElement instanceof HTMLElement &&
                                                                    document.activeElement.blur();
                                                                setSelectedCities(modifiedCityOptions.slice(1))
                                                            } else if (
                                                                selected.length === cityAllData.length &&
                                                                field.value?.length !== cityAllData.length
                                                            ) {
                                                                field.onChange(modifiedCityOptions.slice(1));
                                                                setSelectedCities(modifiedCityOptions.slice(1))
                                                            } else {
                                                                field.onChange(selected);
                                                                setSelectedCities(selected)
                                                            }
                                                        }}
                                                    />
                                                    {selectedValues.length > 2 && (
                                                        <span className="translate-middle-y end-0 me-3 badge rounded-pill bg-light text-primary border border-primary">
                                                            +{selectedValues.length - 2} more
                                                        </span>
                                                    )}
                                                </div>
                                            );
                                        }}
                                    />
                                </div>

                                <div className="col-md-4 ">
                                    <label className="form-label">
                                        Store <span style={{ color: "red" }}>*</span>
                                    </label>

                                    <Controller
                                        name="storeIdList"
                                        control={control}
                                        rules={{
                                            validate: (value) => {
                                                if (!value || value.length === 0) {
                                                    return "Please select at least one store";
                                                }
                                                return true;
                                            },
                                        }}
                                        render={({ field, fieldState: { error } }) => {
                                            const selectedValues: any[] = field.value || [];
                                            const visibleValue = selectedValues[0];
                                            const isSingleOption = modifiedStoreOptions.length === 1;
                                            const isSelected = selectedValues.length > 0;

                                            return (
                                                <div className="position-relative">
                                                    <Select
                                                        {...field}
                                                        options={modifiedStoreOptions}
                                                        isMulti
                                                        closeMenuOnSelect={false}
                                                        hideSelectedOptions={false}
                                                        placeholder="--Select store--"
                                                        className={`react-select-container ${error ? "is-invalid" : ""}`}
                                                        classNamePrefix="react-select"
                                                        value={(field.value || [])
                                                            .map((v: any) => {
                                                                if (typeof v === "string" || typeof v === "number") {
                                                                    return modifiedStoreOptions.find((opt) => opt.value === v) || null;
                                                                }
                                                                return v;
                                                            })
                                                            .filter(Boolean)}
                                                        getOptionLabel={(e: SelectOption) => e.label}
                                                        getOptionValue={(e: SelectOption) => e.value}
                                                        styles={customStyles(selectedValues, visibleValue)}
                                                        menuIsOpen={undefined
                                                        }
                                                        isDisabled={isAllStore || (isSingleOption && isSelected)} // disable clicking when already selected
                                                        onChange={(selected: SelectOption[] | null) => {
                                                            let finalSelected: any[] = [];

                                                            if (!selected) {
                                                                field.onChange([]);
                                                                setSelectedStores([]);
                                                                return;
                                                            }

                                                            if (isSingleOption) {
                                                                finalSelected = selected;
                                                            } else {
                                                                const isSelectAllSelected = selected.some(
                                                                    (option) => option.value === "*"
                                                                );

                                                                if (isSelectAllSelected) {
                                                                    finalSelected = modifiedStoreOptions.slice(1);
                                                                    document.activeElement instanceof HTMLElement &&
                                                                        document.activeElement.blur();
                                                                } else if (
                                                                    selected.length === storeAllData.length &&
                                                                    field.value?.length !== storeAllData.length
                                                                ) {
                                                                    finalSelected = modifiedStoreOptions.slice(1);
                                                                } else {
                                                                    finalSelected = selected;
                                                                }
                                                            }

                                                            field.onChange(finalSelected);
                                                            setSelectedStores(finalSelected);
                                                        }}
                                                    />

                                                    {selectedValues.length > 1 && (
                                                        <span
                                                            className="translate-middle-y end-0 me-3 badge rounded-pill bg-light text-primary border border-primary"
                                                            style={{
                                                                fontSize: "11px",
                                                                fontWeight: "500",
                                                                padding: "3px 6px",
                                                            }}
                                                        >
                                                            +{selectedValues.length - 1} more
                                                        </span>
                                                    )}

                                                    {error && (
                                                        <span className="text-danger" style={{ fontSize: "0.8rem" }}>
                                                            {error.message}
                                                        </span>
                                                    )}
                                                </div>
                                            );
                                        }}
                                    />
                                </div>


                            </div>
                        </> : null}

                        <div className="row mt-2">
                            <div className="col-md-4">
                                <label className="form-label">
                                    Promotion Name <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                    maxLength={50}
                                    className={`form-control form-control-sm ${errors.promotionName ? "is-invalid" : ""}`}
                                    autoComplete="off"
                                    placeholder='Enter promotion name'
                                    type="text"
                                    {...register("promotionName", {
                                        required: "Promotion name is required"
                                    })}
                                    onInput={(e: any) => {
                                        let value = e.target.value.replace(/\s+/g, ' ');
                                        if (value.startsWith(' ')) {
                                            value = value.trimStart();
                                        }
                                        e.target.value = value;
                                    }}
                                />
                                {errors.promotionName && (
                                    <div className="text-danger small mt-1">{errors.promotionName.message}</div>
                                )}
                            </div>
                            <div className="col-md-4">
                                <label className="form-label">
                                    MRP Type <span style={{ color: "red" }}>*</span>
                                </label>
                                <Controller
                                    name="mrpTypeId"
                                    control={control}
                                    rules={{
                                        required: "Please select mrp type"
                                    }}
                                    render={({ field }) => (
                                        <Select
                                            {...field}
                                            options={allMRPTypeData}
                                            placeholder="Select mrp Type"
                                            value={
                                                allMRPTypeData.find(option => option.value === field.value) || null
                                            }
                                            onChange={(selectedOption: any) =>
                                                field.onChange(selectedOption?.value || null)
                                            }
                                            className="form-control form-control-sm p-0 react-select-container"
                                            classNamePrefix="react-select"
                                            styles={{
                                                control: (provided: any, state: any) => ({
                                                    ...provided,
                                                    minHeight: '27px',
                                                    height: '27px',
                                                    fontSize: '12px',
                                                    // padding: '0 2px',
                                                    borderWidth: '1px',
                                                    borderRadius: '0.25rem',
                                                    borderColor: errors.mrpTypeId
                                                        ? "#ff6c6c"
                                                        : state.isFocused ? '#86b7fe' : '#ced4da',
                                                    '&:hover': {
                                                        borderColor: '#86b7fe',
                                                    },
                                                }),
                                                indicatorsContainer: (base: any) => ({
                                                    ...base,
                                                    height: '28px',
                                                }),
                                                dropdownIndicator: (base: any) => ({
                                                    ...base,
                                                    padding: '4px',
                                                    color: '#6c757d',
                                                    ':hover': {
                                                        color: '#495057',
                                                    },
                                                }),
                                                valueContainer: (base: any) => ({
                                                    ...base,
                                                    padding: '0 8px',
                                                }),
                                                input: (base: any) => ({
                                                    ...base,
                                                    margin: 0,
                                                    padding: 0,
                                                }),
                                            }}
                                        />
                                    )}
                                />
                                {errors.mrpTypeId && (
                                    <div className="text-danger small mt-1">{errors.mrpTypeId.message}</div>
                                )}
                            </div>
                            <div className="col-md-4">
                                <label className="form-label">
                                    Discount Type <span style={{ color: "red" }}>*</span>
                                </label>
                                <Controller
                                    name="discountTypeId"
                                    control={control}
                                    rules={{
                                        required: "Please select discount type"
                                    }}
                                    render={({ field }) => (
                                        <Select
                                            {...field}
                                            options={allDiscountTypeData}
                                            placeholder="--Select discount type--"
                                            value={allDiscountTypeData.find(option => option.value === field.value) || null}
                                            onChange={(selectedOption: any) => field.onChange(selectedOption?.value || null)}
                                            className={`react-select-container`}
                                            classNamePrefix="react-select"
                                            styles={{
                                                control: (provided: any, state: any) => ({
                                                    ...provided,
                                                    minHeight: '27px',
                                                    height: '27px',
                                                    fontSize: '12px',
                                                    padding: '0 2px',
                                                    borderWidth: '1px',
                                                    borderRadius: '0.25rem',
                                                    borderColor: errors.discountTypeId
                                                        ? "#ff6c6c"
                                                        : state.isFocused
                                                            ? "#86b7fe"
                                                            : "#ced4da",
                                                    '&:hover': {
                                                        borderColor: '#86b7fe',
                                                    },
                                                }),
                                                indicatorsContainer: (base: any) => ({
                                                    ...base,
                                                    height: '28px',
                                                }),
                                                dropdownIndicator: (base: any) => ({
                                                    ...base,
                                                    padding: '4px',
                                                    color: '#6c757d',
                                                    ':hover': {
                                                        color: '#495057',
                                                    },
                                                }),
                                                valueContainer: (base: any) => ({
                                                    ...base,
                                                    padding: '0 8px',
                                                }),
                                                input: (base: any) => ({
                                                    ...base,
                                                    margin: 0,
                                                    padding: 0,
                                                }),
                                            }}
                                        />
                                    )}
                                />
                                {errors.discountTypeId && (
                                    <div className="text-danger small mt-1">{errors.discountTypeId.message}</div>
                                )}
                            </div>

                            {watchDiscountTypeId === 2 && (
                                <div className="col-md-4 mt-3">
                                    <label className="form-label">Invoice Slab <span className="text-danger">*</span></label>
                                    <Controller
                                        name="invoiceSlabId"
                                        control={control}
                                        rules={{ required: "Invoice slab is required" }}
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                options={invoiceSlabData}
                                                placeholder="--Select invoice slab--"
                                                value={invoiceSlabData.find(option => option.value === field.value) || null}
                                                onChange={(selectedOption: any) => field.onChange(selectedOption?.value || null)}
                                                className="react-select-container"
                                                classNamePrefix="react-select"
                                                isClearable
                                                styles={{
                                                    control: (provided: any, state: any) => ({
                                                        ...provided,
                                                        minHeight: '27px',
                                                        height: '27px',
                                                        fontSize: '12px',
                                                        padding: '0 2px',
                                                        borderWidth: '1px',
                                                        borderRadius: '0.25rem',
                                                        borderColor: state.isFocused || state.isHovered ? '#86b7fe' : '#ced4da',
                                                        boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(13, 110, 253, 0.25)' : 'none',
                                                        transition: 'border-color 0.2s ease-in-out',
                                                    }),
                                                    valueContainer: (base: any) => ({
                                                        ...base,
                                                        padding: '0 8px',
                                                    }),
                                                    indicatorsContainer: (base: any) => ({
                                                        ...base,
                                                        height: '28px',
                                                    }),
                                                    dropdownIndicator: (base: any) => ({
                                                        ...base,
                                                        padding: '4px',
                                                        color: '#6c757d',
                                                        ':hover': {
                                                            color: '#495057',
                                                        },
                                                    }),
                                                    input: (base: any) => ({
                                                        ...base,
                                                        margin: 0,
                                                        padding: 0,
                                                    }),
                                                }}
                                            />
                                        )}
                                    />
                                    {errors.invoiceSlabId && (
                                        <div className="text-danger small mt-1">{errors.invoiceSlabId.message}</div>
                                    )}
                                </div>
                            )}
                            <div className="col-md-4 mt-3">
                                <label className="form-label">
                                    {isPercentage ? "Percentage Discount (%)" : " Discount value"} <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    maxLength={6}
                                    className={`form-control form-control-sm ${errors.discountValue ? "is-invalid" : ""}`}
                                    placeholder="Enter discount"
                                    onInput={(e: any) => {
                                        e.target.value = e.target.value.replace(/\D/g, "").slice(0, 10);
                                    }}
                                    {...register("discountValue", {
                                        required: "Discount value is required",
                                        validate: (value) => {
                                            if (isPercentage) {
                                                if (value === "") return "Discount value is required";
                                                if (Number(value) > 100)
                                                    return "Percentage cannot be more than 100";
                                            }
                                            return true;
                                        },
                                    })}
                                />
                                {errors.discountValue && (
                                    <div className="text-danger small mt-1">{errors.discountValue.message}</div>
                                )}
                            </div>
                            <div className="col-md-4 mt-3">
                                <label className="form-label">
                                    Material Type <span style={{ color: "red" }}>*</span>
                                </label>
                                <Controller
                                    name="materialTypeId"
                                    control={control}
                                    rules={{
                                        required: "Please select material type"
                                    }}
                                    render={({ field }) => (
                                        <Select
                                            {...field}
                                            options={materialTypeData}
                                            placeholder="--Select material type--"
                                            value={materialTypeData.find(option => option.value === field.value) || null}
                                            onChange={(selectedOption: any) => field.onChange(selectedOption?.value || null)}
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            styles={{
                                                control: (provided: any, state: any) => ({
                                                    ...provided,
                                                    minHeight: '27px',
                                                    height: '27px',
                                                    fontSize: '12px',
                                                    padding: '0 2px',
                                                    borderWidth: '1px',
                                                    borderRadius: '0.25rem',
                                                    borderColor: errors.materialTypeId
                                                        ? "#ff6c6c" :
                                                        state.isFocused || state.isHovered ? '#86b7fe' : '#ced4da',
                                                    '&:hover': {
                                                        borderColor: '#86b7fe',
                                                    },
                                                }),
                                                indicatorsContainer: (base: any) => ({
                                                    ...base,
                                                    height: '28px',
                                                }),
                                                dropdownIndicator: (base: any) => ({
                                                    ...base,
                                                    padding: '4px',
                                                    color: '#6c757d',
                                                    ':hover': {
                                                        color: '#495057',
                                                    },
                                                }),
                                                valueContainer: (base: any) => ({
                                                    ...base,
                                                    padding: '0 8px',
                                                }),
                                                input: (base: any) => ({
                                                    ...base,
                                                    margin: 0,
                                                    padding: 0,
                                                }),
                                            }}
                                        />
                                    )}
                                />
                                {errors.materialTypeId && (
                                    <div className="text-danger small mt-1">{errors.materialTypeId.message}</div>
                                )}
                            </div>

                            {/* <div className="col-md-4">
                                <label className="form-label">
                                    Is Style No
                                </label>
                                <Controller
                                    name="isStyleNo"
                                    control={control}
                                    render={({ field }) => (
                                        <select
                                            className="form-control form-control-sm"
                                            value={field.value === true ? "true" : "false"}
                                            onChange={(e) => {
                                                const value = e.target.value === "true";
                                                field.onChange(value);
                                                if (!value) {
                                                    setValue("styleNumber", []);
                                                }
                                            }}
                                        >
                                            <option value="false">No</option>
                                            <option value="true">Yes</option>
                                        </select>
                                    )}
                                />
                            </div> */}


                            <MultiSelectWithSelectAll
                                name="collectionList"
                                control={control}
                                options={collection}
                                allDataLength={collection.length}
                                label="Collection"
                                // required
                                placeholder="--Select collection--"
                            />
                            <MultiSelectWithSelectAll
                                name="categoryList"
                                control={control}
                                options={category}
                                allDataLength={category.length}
                                label="Category"
                                // required
                                placeholder="--Select category--"
                            />
                            <MultiSelectWithSelectAll
                                name="ktTypeList"
                                control={control}
                                options={ktType}
                                allDataLength={ktType.length}
                                label="KT Type"
                                // required
                                placeholder="--Select KT type--"
                            />

                            <MultiSelectWithSelectAll
                                name="styleNumber"
                                control={control}
                                options={styleNumber}
                                allDataLength={styleNumber.length}
                                label="Style Number"
                                // required
                                placeholder="--Select style number--"

                            />
                            <div className="col-md-4 mt-3">
                                <label className="form-label">
                                    From Date <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                    className={`form-control form-control-sm ${errors.fromDate ? "is-invalid" : ""}`}
                                    type="date"
                                    min={getTodayDate()}
                                    {...register("fromDate", {
                                        required: "From date is required"
                                    })}
                                />
                                {errors.fromDate && (
                                    <div className="text-danger small mt-1">{errors.fromDate.message}</div>
                                )}
                            </div>


                            <div className="col-md-4 mt-3">
                                <label className="form-label">
                                    To Date <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                    className={`form-control form-control-sm ${errors.toDate ? "is-invalid" : ""}`}
                                    type="date"
                                    min={watchFromDate || getTodayDate()}
                                    {...register("toDate", {
                                        required: "To date is required",
                                        validate: (value) => {
                                            const fromDate = watchFromDate;
                                            if (fromDate && value) {
                                                const fromDateParsed = new Date(fromDate);
                                                const toDateParsed = new Date(value);
                                                if (fromDateParsed && toDateParsed && toDateParsed < fromDateParsed) {
                                                    return "To date cannot be before From date";
                                                }
                                            }
                                            return true;
                                        }
                                    })}
                                />
                                {errors.toDate && (
                                    <div className="text-danger small mt-1">{errors.toDate.message}</div>
                                )}
                            </div>

                        </div>
                        <div className='d-flex gap-3'>
                            {watchMrpTypeId === 1 && (
                                <div className="col-md-4 mt-3">
                                    <label className="form-label">
                                        Discount on MRP <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <Controller
                                        name="discountOnMRPOptionId"
                                        control={control}
                                        rules={{
                                            required: "Please select discount on mrp"
                                        }}
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                options={allDiscountOnMRP}
                                                placeholder="--Select discount on mrp --"
                                                value={allDiscountOnMRP.find(option => option.value === field.value) || null}
                                                onChange={(selectedOption: any) => field.onChange(selectedOption?.value || null)}
                                                className="react-select-container"
                                                classNamePrefix="react-select"


                                                styles={{
                                                    control: (provided: any, state: any) => ({
                                                        ...provided,
                                                        minHeight: '27px',
                                                        height: '27px',
                                                        width: "15rem",
                                                        fontSize: '12px',
                                                        padding: '0 2px',
                                                        borderWidth: '1px',
                                                        borderRadius: '0.25rem',
                                                        borderColor: state.isFocused || state.isHovered ? '#86b7fe' : '#ced4da',
                                                        '&:hover': {
                                                            borderColor: '#86b7fe',
                                                        },
                                                    }),
                                                    indicatorsContainer: (base: any) => ({
                                                        ...base,
                                                        height: '28px',
                                                    }),
                                                    dropdownIndicator: (base: any) => ({
                                                        ...base,
                                                        padding: '4px',
                                                        color: '#6c757d',
                                                        ':hover': {
                                                            color: '#495057',
                                                        },
                                                    }),
                                                    valueContainer: (base: any) => ({
                                                        ...base,
                                                        padding: '0 8px',
                                                    }),
                                                    input: (base: any) => ({
                                                        ...base,
                                                        margin: 0,
                                                        padding: 0,
                                                    }),
                                                }}
                                            />
                                        )}
                                    />
                                    {errors.discountOnMRPOptionId && (
                                        <div className="text-danger small mt-1">{errors.discountOnMRPOptionId.message}</div>
                                    )}
                                </div>
                            )}
                            {watchMrpTypeId === 2 && (
                                <div className="col-md-4 mt-3">
                                    <label className="form-label">
                                        Discount on SRP <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <Controller
                                        name="discountOnSRPOptionId"
                                        control={control}
                                        rules={{
                                            required: "Please select discount on SRP"
                                        }}
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                options={allDiscountOnSRP}
                                                placeholder="--Select discount on srp--"
                                                value={allDiscountOnSRP.find(option => option.value === field.value) || null}
                                                onChange={(selectedOption: any) => field.onChange(selectedOption?.value || null)}
                                                className="react-select-container"
                                                classNamePrefix="react-select"

                                                styles={{
                                                    control: (provided: any, state: any) => ({
                                                        ...provided,
                                                        width: "15rem",
                                                        minHeight: '27px',
                                                        height: '27px',
                                                        fontSize: '12px',
                                                        padding: '0 2px',
                                                        borderWidth: '1px',
                                                        borderRadius: '0.25rem',
                                                        borderColor: state.isFocused || state.isHovered ? '#86b7fe' : '#ced4da',
                                                        '&:hover': {
                                                            borderColor: '#86b7fe',
                                                        },
                                                    }),
                                                    indicatorsContainer: (base: any) => ({
                                                        ...base,
                                                        height: '28px',
                                                    }),
                                                    dropdownIndicator: (base: any) => ({
                                                        ...base,
                                                        padding: '4px',
                                                        color: '#6c757d',
                                                        ':hover': {
                                                            color: '#495057',
                                                        },
                                                    }),
                                                    valueContainer: (base: any) => ({
                                                        ...base,
                                                        padding: '0 8px',
                                                    }),
                                                    input: (base: any) => ({
                                                        ...base,
                                                        margin: 0,
                                                        padding: 0,
                                                    }),
                                                }}
                                            />
                                        )}
                                    />
                                    {errors.discountOnSRPOptionId && (
                                        <div className="text-danger small mt-1">{errors.discountOnSRPOptionId.message}</div>
                                    )}
                                </div>
                            )}
                        </div>

                        <div className="row mt-3">
                            <div className="col-sm-12">
                                <div className="d-flex flex-wrap gap-3">
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="percentage"
                                            checked={isPercentage}
                                            onChange={(e) => {
                                                const checked = e.target.checked;
                                                setValue("isPercentage", checked);
                                                setValue("discountValue", "");
                                                trigger("discountValue");
                                            }}
                                        />
                                        <label className="form-check-label" htmlFor='percentage'>Percentage Discount</label>
                                    </div>
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            {...register("isDefault")}
                                            id='promotion'
                                        />
                                        <label className="form-check-label" htmlFor='promotion'>Default Promotion</label>
                                    </div>

                                    {/* <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="allStores"
                                            {...register("isAllStore")}
                                            checked={isAllStore}
                                            onChange={handleAllStoresChange}
                                        />
                                        <label className="form-check-label" htmlFor='allStores'>All Stores</label>
                                    </div> */}

                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="isClub"
                                            {...register("isClub")}
                                            checked={isClub}
                                            onChange={handleAllowOfferCombinationChange}
                                        />
                                        <label className="form-check-label" htmlFor='allStores'>Allow Offer Combination</label>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div className="d-flex justify-content-end align-items-end mt-4">
                            <button type="button" className="btn add-btn me-2" onClick={closeModal}>
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="btn submit-btn"
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? "Creating..." : "Add"}
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>

            <DuplicateOffersModal
                show={showDublicateDataModal}
                onClose={() => setShowDublicateDataModal(false)}
                message={confirmMsg}
                duplicateData={dublicateData || []}
                onConfirm={async () => {
                    if (!payload) return;
                    const confirmedPayload = { ...payload, isConfirm: true };
                    const response: any = await createDiscount(confirmedPayload);
                    if (response?.status === 200) {
                        notistack.notifyFromApi(response);
                        setShowDublicateDataModal(false);
                        closeModal();
                        reloadDataSource();
                    } else {
                        notistack.warning(response.message);
                    }
                }}
            />

        </>
    );
};

export default AddDiscount;